import React, { useEffect, useState } from 'react';
import { useThemeMode } from 'components/common/AppStoreType';
import { useLocation, useNavigate } from 'react-router-dom';
import { Accordion, Col, Row } from 'react-bootstrap';
import klaytn from '../../assets/svg/klaytnFaucet.svg';
import polygon from '../../assets/icon/polygon.svg';
import binance from 'assets/img/icon_binance.png';
import eth from '../../assets/icon/eth.svg';
import talk from '../../talkclaim/talk.png';
import talkKlaytn from '../../assets/icon/TANK_symbol-Klaytn.svg';
import talkEthereum from '../../assets/icon/talkEthereum.svg';
import talkPolygon from '../../assets/icon/talkPolygon.svg';
import talkBinance from '../../assets/icon/talkBinance.svg';
import { ReactComponent as Download } from '../../assets/icon/download.svg';
import { ReactComponent as Send } from '../../assets/icon/send.svg';
import { ReactComponent as Trans } from '../../assets/icon/trans.svg';
import WalletDetailModal from 'components/WalletDetailModal/WalletDetailModal';
import TransferModal from 'components/modal/TransferModal';
import TranferOTPModal from 'components/modal/TranferOTPModal';
import TransferSuccessModal from 'components/modal/TransferSuccessModal';
import {
  getBnbBalance,
  getErc20Balance,
  getEthBalance,
  getKlayBalance,
  getMaticBalance,
} from '../../utils/transactions';
import useActiveWeb3React from '../../hooks/useActiveWeb3React';
import contracts from '../../config/constants/contracts';
import env from '../../env';
import { ChainId, SCAN_URL } from '../../config';
import { useSelector } from 'react-redux';
import { getActiveWallet } from '../../utils/getActiveWallet';
// import WrapUnwrapKlay from '../modal/WrapUnwrapKlay';
import TransferSuccessWklay from '../modal/TransferSuccessWklay';
import TalkenBridge from '../modal/TalkenBridge';
import TalkenBridgeSuccess from '../modal/TalkenBridgeSuccess';
import { Divider } from '@mui/material';
import { useEagerConnect, useInactiveListener } from '../../hooks/useWallet';
import { RootState } from '../../redux/Store';
const AggregateUserInfor = () => {
  const isProduction = process.env.REACT_APP_PHASE === 'production';
  const { isDarkMode } = useThemeMode();
  const navigate = useNavigate();
  const location = useLocation();
  const [isShowDetaiWallet, setIsShowDetailWallet] = useState(false);
  const [isOpenTransfer, setIsOpenTransfer] = useState(false);
  // const [isOpenTransferKlayToWklay, setIsOpenTransferWklay] = useState(false);
  const [isOpenTalkenBridge, setIsOpenTalkenBridge] = useState(false);
  const [isOpenTransferOTP, setIsOpenTransferOTP] = useState(false);
  const [isOpenTransferSucces, setIsOpenTransferSucces] = useState(false);
  const [isOpenWrapSucces, setIsOpenWrapSucces] = useState(false);
  const [isOpenTalkenBridgeSucces, setIsOpenTalkenBridgeSucces] = useState(false);
  const [walletInfo, setWalletInfo] = useState({ img_url: '', token: '', linkTo: '' });
  const [transferInfo, setTransferInfo] = useState({});
  const [dataComplete, setDataComplete] = useState({});
  const [dataWrapComplete, setDataWrapComplete] = useState({});
  const [dataTalkenBridgeComplete, setDataTalkenBridgeComplete] = useState({});

  const { deactivate, account, library } = useActiveWeb3React();
  const login = window.localStorage.getItem('login');
  const user = useSelector((state: any) => state.user.user);
  const myWallet = getActiveWallet();
  const userExtAddr = user.eth_address?.toLowerCase();
  const abcUser = JSON.parse(window.localStorage.getItem('abcUser') as string);
  const [ethBal, setEthBal] = useState('0.0');
  const [klayBal, setKlayBal] = useState('0.0');
  const [maticBal, setMaticBal] = useState('0.0');
  const [bnbBal, setBnbBal] = useState('0.0');
  const [talkBals, setTalkBals] = useState([]);
  const [wklayBal, setWklayBal] = useState('0.0');
  // const [wklayData, setWklayData] = useState({ klay: undefined, wklay: undefined });
  const [myAddress, setMyAddress] = useState(login == 'sns' ? myWallet : userExtAddr);
  const userEthAddr = user.abc_address?.toLowerCase();
  const [reload, setReload] = useState(false);
  const [selected, setSelected] = useState(0);
  const { activatingConnector } = useSelector((state: RootState) => state.wallet);
  const triedEager = useEagerConnect();
  useInactiveListener(!triedEager || !!activatingConnector);

  const openDetailModal = (img_url, token, linkTo) => {
    if ((!userEthAddr || (userEthAddr && !abcUser?.twoFactorEnabled)) && login == 'sns') {
      alert('Please activate ABC Wallet first');
    } else {
      setWalletInfo({ img_url: img_url, token: token, linkTo: linkTo + token });
      setIsShowDetailWallet(true);
    }
  };
  const isOpenTransferModal = (value, balance, address) => {
    if (login == 'metamask') {
      alert('Please use MetaMask to transfer tokens.');
      return;
    }
    if (!userEthAddr || (userEthAddr && !abcUser?.twoFactorEnabled && login === 'sns')) {
      alert('Please activate ABC Wallet first');
    } else {
      setTransferInfo({ value: value, balance: balance, address: address });
      setIsOpenTransfer(true);
    }
  };
  // const isOpenTransferWklay = (value, balance, address) => {
  //   if (!userEthAddr || (userEthAddr && !abcUser?.twoFactorEnabled)) {
  //     alert('Please activate ABC Wallet first');
  //   } else {
  //     setTransferInfo({ value: value, balance: balance, address: address });
  //     setIsOpenTransferWklay(true);
  //   }
  // };
  const onClickOpenTransferTalkenBridge = (index: number) => {
    // if (isProduction) {
    //   alert('Coming Soon');
    //   return;
    // }
    if ((!userEthAddr || (userEthAddr && !abcUser?.twoFactorEnabled)) && login == 'sns') {
      alert('Please activate ABC Wallet first');
    } else {
      setSelected(index);
      // setIsOpenTalkenBridge(true);
      window.location.href = '/bridge';
    }
  };
  const fetchTalkBalance = async () => {
    const Chains = [
      env.REACT_APP_TARGET_NETWORK_ETH,
      env.REACT_APP_TARGET_NETWORK_MATIC,
      env.REACT_APP_TARGET_NETWORK_KLAY,
      env.REACT_APP_TARGET_NETWORK_BNB,
    ];
    const values: string[] = [];
    for (let i = 0; i < Chains.length; i++) {
      const value = await getErc20Balance(contracts?.talken[Chains[i]], myWallet, Chains[i], 18);
      values.push(value);
    }
    setTalkBals(values);
  };
  // const fetchWklayBalance = async () => {
  //   const wklayBalance = await getErc20Balance(
  //     contracts?.wklay[env.REACT_APP_TARGET_NETWORK_KLAY],
  //     myWallet,
  //     env.REACT_APP_TARGET_NETWORK_KLAY,
  //     18
  //   );
  //   setWklayBal(wklayBalance);
  // };
  const fetchKlayBalance = async () => {
    const value = await getKlayBalance(myWallet);
    setKlayBal(value);
  };
  const fetchEthBalance = async () => {
    const value = await getEthBalance(myWallet);
    setEthBal(value);
  };
  const fetchMaticBalance = async () => {
    const value = await getMaticBalance(myWallet);
    setMaticBal(value);
  };
  const fetchBnbBalance = async () => {
    const value = await getBnbBalance(myWallet);
    setBnbBal(value);
  };

  const sumTalkBal = (talkBal: string[]): string => {
    let sum = 0;
    for (let i = 0; i < talkBal.length; i++) {
      sum += parseFloat(talkBal[i]);
    }
    return sum.toFixed(3);
  };

  useEffect(() => {
    setMyAddress(myWallet);
  }, [account, myWallet]);

  // useEffect(() => {
  //   if (wklayBal !== '0.0' && klayBal !== '0.0') {
  //     setWklayData({
  //       klay: klayBal,
  //       wklay: wklayBal,
  //     });
  //   }
  // }, [myWallet, wklayBal, klayBal]);
  useEffect(() => {
    if (myWallet) fetchKlayBalance();
  }, [myWallet]);
  useEffect(() => {
    if (myWallet) fetchEthBalance();
  }, [myWallet]);
  useEffect(() => {
    if (myWallet) fetchMaticBalance();
  }, [myWallet]);
  useEffect(() => {
    if (myWallet) fetchBnbBalance();
  }, [myWallet]);
  useEffect(() => {
    if (myWallet) fetchTalkBalance();
  }, [myWallet]);
  // useEffect(() => {
  //   fetchWklayBalance();
  // }, [myWallet]);
  useEffect(() => {
    if (reload) {
      if (myWallet) fetchTalkBalance();
      // fetchWklayBalance();
      fetchKlayBalance();
      fetchEthBalance();
      setReload(false);
    }
  }, [reload]);

  useEffect(() => {
    const tick = setTimeout(() => {
      if (myWallet) fetchTalkBalance();
    }, 60000);
    return () => clearTimeout(tick);
  }, [reload]);

  // const onHideWrap = (data) => {
  //   // if (data?.txid) {
  //   if (data) {
  //     setDataWrapComplete(data);
  //     setIsOpenWrapSucces(true);
  //   }
  //
  //   setIsOpenTransferWklay(false);
  // };
  return (
    <>
      <div className="aggregate-user-infor p-0 bg-transparent">
        <div className="mobile-hiden bg-box-card p-3 rounded-3 w-100">
          <button
            className={`select-infor-item button w-100 mb-3 ${
              location.pathname === '/profile' ? 'focus-select-infor' : ''
            }`}
            onClick={() => navigate('/profile')}
          >
            <div className="img-select-infor">
              {isDarkMode ? (
                <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M19.0801 11.6669C19.1614 11.2262 19.1614 10.7761 19.0801 10.3355L19.8865 9.86979C19.9802 9.81666 20.0209 9.70727 19.9896 9.60414C19.7802 8.92907 19.4208 8.3165 18.952 7.8102C18.8801 7.73207 18.7645 7.71331 18.6707 7.76644L17.8644 8.23212C17.5237 7.94146 17.1331 7.71644 16.7111 7.56642V6.63508C16.7111 6.52881 16.6361 6.43505 16.533 6.41318C15.836 6.25691 15.1266 6.26316 14.464 6.41318C14.3609 6.43505 14.2859 6.52881 14.2859 6.63508V7.56642C13.864 7.71644 13.4733 7.94146 13.1326 8.23212L12.3263 7.76644C12.2357 7.71331 12.1169 7.73207 12.045 7.8102C11.5762 8.3165 11.2168 8.92907 11.0074 9.60414C10.9762 9.70727 11.0199 9.81666 11.1105 9.86979L11.9169 10.3355C11.8356 10.7761 11.8356 11.2262 11.9169 11.6669L11.1105 12.1325C11.0168 12.1857 10.9762 12.295 11.0074 12.3982C11.2168 13.0733 11.5762 13.6827 12.045 14.1921C12.1169 14.2703 12.2325 14.289 12.3263 14.2359L13.1326 13.7702C13.4733 14.0609 13.864 14.2859 14.2859 14.4359V15.3672C14.2859 15.4735 14.3609 15.5673 14.464 15.5891C15.161 15.7454 15.8704 15.7392 16.533 15.5891C16.6361 15.5673 16.7111 15.4735 16.7111 15.3672V14.4359C17.1331 14.2859 17.5237 14.0609 17.8644 13.7702L18.6707 14.2359C18.7614 14.289 18.8801 14.2703 18.952 14.1921C19.4208 13.6858 19.7802 13.0733 19.9896 12.3982C20.0209 12.295 19.9771 12.1857 19.8865 12.1325L19.0801 11.6669V11.6669ZM15.5016 12.5169C14.664 12.5169 13.9859 11.8356 13.9859 11.0012C13.9859 10.1667 14.6672 9.48538 15.5016 9.48538C16.3361 9.48538 17.0174 10.1667 17.0174 11.0012C17.0174 11.8356 16.3392 12.5169 15.5016 12.5169ZM7.00074 8.00084C9.21035 8.00084 11.0012 6.21003 11.0012 4.00042C11.0012 1.79081 9.21035 0 7.00074 0C4.79113 0 3.00032 1.79081 3.00032 4.00042C3.00032 6.21003 4.79113 8.00084 7.00074 8.00084ZM13.2889 15.0797C13.217 15.0422 13.1451 14.9985 13.0764 14.9578L12.8295 15.1016C12.642 15.2079 12.4294 15.2672 12.2169 15.2672C11.8763 15.2672 11.5481 15.1235 11.3137 14.8734C10.7418 14.2546 10.3042 13.5014 10.0573 12.6982C9.88542 12.145 10.1167 11.5606 10.6167 11.2699L10.8636 11.1262C10.8605 11.0449 10.8605 10.9637 10.8636 10.8824L10.6167 10.7386C10.1167 10.4511 9.88542 9.86354 10.0573 9.31036C10.0854 9.21972 10.1261 9.12909 10.1573 9.03845C10.0386 9.02908 9.92292 9.00095 9.80103 9.00095H9.2791C8.58528 9.31973 7.81332 9.501 7.00074 9.501C6.18815 9.501 5.41932 9.31973 4.72237 9.00095H4.20044C1.88145 9.00095 0 10.8824 0 13.2014V14.5015C0 15.3297 0.671946 16.0017 1.50016 16.0017H12.5013C12.817 16.0017 13.1108 15.9017 13.3514 15.736C13.3139 15.6173 13.2889 15.4954 13.2889 15.3672V15.0797Z"
                    fill="#8787d6"
                  />
                </svg>
              ) : (
                <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M19.0801 11.6669C19.1614 11.2262 19.1614 10.7761 19.0801 10.3355L19.8865 9.86979C19.9802 9.81666 20.0209 9.70727 19.9896 9.60414C19.7802 8.92907 19.4208 8.3165 18.952 7.8102C18.8801 7.73207 18.7645 7.71331 18.6707 7.76644L17.8644 8.23212C17.5237 7.94146 17.1331 7.71644 16.7111 7.56642V6.63508C16.7111 6.52881 16.6361 6.43505 16.533 6.41318C15.836 6.25691 15.1266 6.26316 14.464 6.41318C14.3609 6.43505 14.2859 6.52881 14.2859 6.63508V7.56642C13.864 7.71644 13.4733 7.94146 13.1326 8.23212L12.3263 7.76644C12.2357 7.71331 12.1169 7.73207 12.045 7.8102C11.5762 8.3165 11.2168 8.92907 11.0074 9.60414C10.9762 9.70727 11.0199 9.81666 11.1105 9.86979L11.9169 10.3355C11.8356 10.7761 11.8356 11.2262 11.9169 11.6669L11.1105 12.1325C11.0168 12.1857 10.9762 12.295 11.0074 12.3982C11.2168 13.0733 11.5762 13.6827 12.045 14.1921C12.1169 14.2703 12.2325 14.289 12.3263 14.2359L13.1326 13.7702C13.4733 14.0609 13.864 14.2859 14.2859 14.4359V15.3672C14.2859 15.4735 14.3609 15.5673 14.464 15.5891C15.161 15.7454 15.8704 15.7392 16.533 15.5891C16.6361 15.5673 16.7111 15.4735 16.7111 15.3672V14.4359C17.1331 14.2859 17.5237 14.0609 17.8644 13.7702L18.6707 14.2359C18.7614 14.289 18.8801 14.2703 18.952 14.1921C19.4208 13.6858 19.7802 13.0733 19.9896 12.3982C20.0209 12.295 19.9771 12.1857 19.8865 12.1325L19.0801 11.6669V11.6669ZM15.5016 12.5169C14.664 12.5169 13.9859 11.8356 13.9859 11.0012C13.9859 10.1667 14.6672 9.48538 15.5016 9.48538C16.3361 9.48538 17.0174 10.1667 17.0174 11.0012C17.0174 11.8356 16.3392 12.5169 15.5016 12.5169ZM7.00074 8.00084C9.21035 8.00084 11.0012 6.21003 11.0012 4.00042C11.0012 1.79081 9.21035 0 7.00074 0C4.79113 0 3.00032 1.79081 3.00032 4.00042C3.00032 6.21003 4.79113 8.00084 7.00074 8.00084ZM13.2889 15.0797C13.217 15.0422 13.1451 14.9985 13.0764 14.9578L12.8295 15.1016C12.642 15.2079 12.4294 15.2672 12.2169 15.2672C11.8763 15.2672 11.5481 15.1235 11.3137 14.8734C10.7418 14.2546 10.3042 13.5014 10.0573 12.6982C9.88542 12.145 10.1167 11.5606 10.6167 11.2699L10.8636 11.1262C10.8605 11.0449 10.8605 10.9637 10.8636 10.8824L10.6167 10.7386C10.1167 10.4511 9.88542 9.86354 10.0573 9.31036C10.0854 9.21972 10.1261 9.12909 10.1573 9.03845C10.0386 9.02908 9.92292 9.00095 9.80103 9.00095H9.2791C8.58528 9.31973 7.81332 9.501 7.00074 9.501C6.18815 9.501 5.41932 9.31973 4.72237 9.00095H4.20044C1.88145 9.00095 0 10.8824 0 13.2014V14.5015C0 15.3297 0.671946 16.0017 1.50016 16.0017H12.5013C12.817 16.0017 13.1108 15.9017 13.3514 15.736C13.3139 15.6173 13.2889 15.4954 13.2889 15.3672V15.0797Z"
                    fill="#595959"
                  />
                </svg>
              )}
            </div>
            <div className="title-select-infor">Profile</div>
          </button>
          <button
            className={`select-infor-item button w-100 mb-3 ${
              location.pathname === '/my-items' ? 'focus-select-infor' : ''
            }`}
            onClick={() => navigate('/my-items')}
          >
            <div className="img-select-infor">
              {isDarkMode ? (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13 5.5C13.0001 5.10204 13.1583 4.72044 13.4398 4.43913C13.7213 4.15783 14.103 3.99987 14.501 4C14.899 4.00013 15.2806 4.15835 15.5619 4.43984C15.8432 4.72133 16.0011 5.10304 16.001 5.501C16.0009 5.89896 15.8427 6.28056 15.5612 6.56187C15.2797 6.84317 14.898 7.00113 14.5 7.001C14.102 7.00087 13.7204 6.84265 13.4391 6.56116C13.1578 6.27967 12.9999 5.89796 13 5.5V5.5ZM2 18H16C16 18.5304 15.7893 19.0391 15.4142 19.4142C15.0391 19.7893 14.5304 20 14 20H2C0.9 20 0 19.1 0 18V6C0 5.46957 0.210714 4.96086 0.585786 4.58579C0.960859 4.21071 1.46957 4 2 4V18ZM20 2V14C20 14.5304 19.7893 15.0391 19.4142 15.4142C19.0391 15.7893 18.5304 16 18 16H6C5.46957 16 4.96086 15.7893 4.58579 15.4142C4.21071 15.0391 4 14.5304 4 14V2C4 1.46957 4.21071 0.960859 4.58579 0.585786C4.96086 0.210714 5.46957 0 6 0H18C18.5304 0 19.0391 0.210714 19.4142 0.585786C19.7893 0.960859 20 1.46957 20 2ZM6 2V8.333L9 5L13.855 10.395L14.511 9.664C14.6986 9.45515 14.928 9.28813 15.1844 9.17379C15.4407 9.05945 15.7183 9.00036 15.999 9.00036C16.2797 9.00036 16.5573 9.05945 16.8136 9.17379C17.07 9.28813 17.2994 9.45515 17.487 9.664L18 10.234V2H6Z"
                    fill="#8787d6"
                  />
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13 5.5C13.0001 5.10204 13.1583 4.72044 13.4398 4.43913C13.7213 4.15783 14.103 3.99987 14.501 4C14.899 4.00013 15.2806 4.15835 15.5619 4.43984C15.8432 4.72133 16.0011 5.10304 16.001 5.501C16.0009 5.89896 15.8427 6.28056 15.5612 6.56187C15.2797 6.84317 14.898 7.00113 14.5 7.001C14.102 7.00087 13.7204 6.84265 13.4391 6.56116C13.1578 6.27967 12.9999 5.89796 13 5.5V5.5ZM2 18H16C16 18.5304 15.7893 19.0391 15.4142 19.4142C15.0391 19.7893 14.5304 20 14 20H2C0.9 20 0 19.1 0 18V6C0 5.46957 0.210714 4.96086 0.585786 4.58579C0.960859 4.21071 1.46957 4 2 4V18ZM20 2V14C20 14.5304 19.7893 15.0391 19.4142 15.4142C19.0391 15.7893 18.5304 16 18 16H6C5.46957 16 4.96086 15.7893 4.58579 15.4142C4.21071 15.0391 4 14.5304 4 14V2C4 1.46957 4.21071 0.960859 4.58579 0.585786C4.96086 0.210714 5.46957 0 6 0H18C18.5304 0 19.0391 0.210714 19.4142 0.585786C19.7893 0.960859 20 1.46957 20 2ZM6 2V8.333L9 5L13.855 10.395L14.511 9.664C14.6986 9.45515 14.928 9.28813 15.1844 9.17379C15.4407 9.05945 15.7183 9.00036 15.999 9.00036C16.2797 9.00036 16.5573 9.05945 16.8136 9.17379C17.07 9.28813 17.2994 9.45515 17.487 9.664L18 10.234V2H6Z"
                    fill="#595959"
                  />
                </svg>
              )}
            </div>
            <div className="title-select-infor">My Items</div>
          </button>
          {true && (
            <button
              className={`select-infor-item button w-100 mb-3 ${
                location.pathname === '/rewards' ? 'focus-select-infor' : ''
              }`}
              onClick={() => navigate('/rewards')}
            >
              <div className="img-select-infor">
                {isDarkMode ? (
                  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M1.61136 6.46875C1.41743 7.24398 1.31445 8.05512 1.31445 8.89024C1.31445 8.89452 1.31446 8.8988 1.31446 8.90308C1.02731 9.71678 0.871094 10.5922 0.871094 11.504C0.871094 15.8243 4.37806 19.3266 8.70413 19.3266C9.64146 19.3266 10.5403 19.1622 11.3734 18.8606C12.2172 18.8544 13.0364 18.7434 13.8185 18.5399C12.3829 19.5824 10.616 20.1973 8.70532 20.1973C3.89859 20.1973 0.00195312 16.3058 0.00195312 11.5055C0.00195312 9.62807 0.597975 7.88969 1.61136 6.46875Z"
                      fill="#8787D6"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M11.2971 17.5789C16.1039 17.5789 20.0005 13.6874 20.0005 8.8871C20.0005 4.08676 16.1039 0.195312 11.2971 0.195312C6.49038 0.195312 2.59375 4.08676 2.59375 8.8871C2.59375 13.6874 6.49038 17.5789 11.2971 17.5789ZM12.2459 5.04458C11.9409 4.13518 10.6546 4.13517 10.3497 5.04458L9.99335 6.10708C9.85776 6.51141 9.48067 6.78526 9.05423 6.7891L7.93505 6.79916C6.97517 6.80779 6.57767 8.03249 7.3495 8.60319L8.24677 9.26663C8.59008 9.52048 8.73435 9.96431 8.60592 10.3715L8.26998 11.4366C7.98137 12.3516 9.02202 13.1085 9.80364 12.552L10.7178 11.9012C11.065 11.654 11.5306 11.654 11.8777 11.9012L12.7919 12.552C13.5735 13.1085 14.6142 12.3516 14.3256 11.4366L13.9896 10.3715C13.8612 9.96431 14.0055 9.52048 14.3488 9.26663L15.246 8.60319C16.0179 8.03249 15.6204 6.80779 14.6605 6.79916L13.5413 6.7891C13.1149 6.78526 12.7378 6.51141 12.6022 6.10709L12.2459 5.04458Z"
                      fill="#8787D6"
                    />
                  </svg>
                ) : (
                  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M1.61136 6.46875C1.41743 7.24398 1.31445 8.05512 1.31445 8.89024C1.31445 8.89452 1.31446 8.8988 1.31446 8.90308C1.02731 9.71678 0.871094 10.5922 0.871094 11.504C0.871094 15.8243 4.37806 19.3266 8.70413 19.3266C9.64146 19.3266 10.5403 19.1622 11.3734 18.8606C12.2172 18.8544 13.0364 18.7434 13.8185 18.5399C12.3829 19.5824 10.616 20.1973 8.70532 20.1973C3.89859 20.1973 0.00195312 16.3058 0.00195312 11.5055C0.00195312 9.62807 0.597975 7.88969 1.61136 6.46875Z"
                      fill="#595959"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M11.2971 17.5789C16.1039 17.5789 20.0005 13.6874 20.0005 8.8871C20.0005 4.08676 16.1039 0.195312 11.2971 0.195312C6.49038 0.195312 2.59375 4.08676 2.59375 8.8871C2.59375 13.6874 6.49038 17.5789 11.2971 17.5789ZM12.2459 5.04458C11.9409 4.13518 10.6546 4.13517 10.3497 5.04458L9.99335 6.10708C9.85776 6.51141 9.48067 6.78526 9.05423 6.7891L7.93505 6.79916C6.97517 6.80779 6.57767 8.03249 7.3495 8.60319L8.24677 9.26663C8.59008 9.52048 8.73435 9.96431 8.60592 10.3715L8.26998 11.4366C7.98137 12.3516 9.02202 13.1085 9.80364 12.552L10.7178 11.9012C11.065 11.654 11.5306 11.654 11.8777 11.9012L12.7919 12.552C13.5735 13.1085 14.6142 12.3516 14.3256 11.4366L13.9896 10.3715C13.8612 9.96431 14.0055 9.52048 14.3488 9.26663L15.246 8.60319C16.0179 8.03249 15.6204 6.80779 14.6605 6.79916L13.5413 6.7891C13.1149 6.78526 12.7378 6.51141 12.6022 6.10709L12.2459 5.04458Z"
                      fill="#595959"
                    />
                  </svg>
                )}
              </div>
              <div className="title-select-infor">Rewards</div>
            </button>
          )}
          <button
            className={`select-infor-item button w-100 ${location.pathname === '/history' ? 'focus-select-infor' : ''}`}
            onClick={() => navigate('/history')}
          >
            <div className="img-select-infor">
              {isDarkMode ? (
                <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.2 5.80039V0.400391H1.8C1.32261 0.400391 0.864773 0.590033 0.527208 0.927598C0.189642 1.26516 0 1.723 0 2.20039V17.8004C0 18.2778 0.189642 18.7356 0.527208 19.0732C0.864773 19.4107 1.32261 19.6004 1.8 19.6004H7.5084C6.66204 18.5777 6.14536 17.3226 6.0264 16.0004H5.4C5.24087 16.0004 5.08826 15.9372 4.97574 15.8247C4.86321 15.7121 4.8 15.5595 4.8 15.4004C4.8 15.2413 4.86321 15.0886 4.97574 14.9761C5.08826 14.8636 5.24087 14.8004 5.4 14.8004H6.0264C6.06304 14.3944 6.13736 13.9926 6.2484 13.6004H5.4C5.24087 13.6004 5.08826 13.5372 4.97574 13.4247C4.86321 13.3121 4.8 13.1595 4.8 13.0004C4.8 12.8413 4.86321 12.6886 4.97574 12.5761C5.08826 12.4636 5.24087 12.4004 5.4 12.4004H6.72C6.9396 11.9708 7.2048 11.5688 7.5084 11.2004H5.4C5.24087 11.2004 5.08826 11.1372 4.97574 11.0247C4.86321 10.9121 4.8 10.7595 4.8 10.6004C4.8 10.4413 4.86321 10.2886 4.97574 10.1761C5.08826 10.0636 5.24087 10.0004 5.4 10.0004H8.8044C9.8784 9.24439 11.1876 8.80039 12.6 8.80039C13.2086 8.79981 13.8143 8.8834 14.4 9.04879V7.60039H9C8.52261 7.60039 8.06477 7.41075 7.72721 7.07318C7.38964 6.73562 7.2 6.27778 7.2 5.80039ZM2.4 10.6004C2.4 10.4413 2.46321 10.2886 2.57574 10.1761C2.68826 10.0636 2.84087 10.0004 3 10.0004C3.15913 10.0004 3.31174 10.0636 3.42426 10.1761C3.53679 10.2886 3.6 10.4413 3.6 10.6004C3.6 10.7595 3.53679 10.9121 3.42426 11.0247C3.31174 11.1372 3.15913 11.2004 3 11.2004C2.84087 11.2004 2.68826 11.1372 2.57574 11.0247C2.46321 10.9121 2.4 10.7595 2.4 10.6004ZM2.4 13.0004C2.4 12.8413 2.46321 12.6886 2.57574 12.5761C2.68826 12.4636 2.84087 12.4004 3 12.4004C3.15913 12.4004 3.31174 12.4636 3.42426 12.5761C3.53679 12.6886 3.6 12.8413 3.6 13.0004C3.6 13.1595 3.53679 13.3121 3.42426 13.4247C3.31174 13.5372 3.15913 13.6004 3 13.6004C2.84087 13.6004 2.68826 13.5372 2.57574 13.4247C2.46321 13.3121 2.4 13.1595 2.4 13.0004ZM3 14.8004C3.15913 14.8004 3.31174 14.8636 3.42426 14.9761C3.53679 15.0886 3.6 15.2413 3.6 15.4004C3.6 15.5595 3.53679 15.7121 3.42426 15.8247C3.31174 15.9372 3.15913 16.0004 3 16.0004C2.84087 16.0004 2.68826 15.9372 2.57574 15.8247C2.46321 15.7121 2.4 15.5595 2.4 15.4004C2.4 15.2413 2.46321 15.0886 2.57574 14.9761C2.68826 14.8636 2.84087 14.8004 3 14.8004Z"
                    fill="#8787d6"
                  />
                  <path
                    d="M8.4002 5.80117V0.701172L14.1002 6.40117H9.0002C8.84107 6.40117 8.68845 6.33796 8.57593 6.22544C8.46341 6.11291 8.4002 5.9603 8.4002 5.80117ZM18.0002 15.4012C18.0002 16.8333 17.4313 18.2069 16.4186 19.2195C15.4059 20.2322 14.0324 20.8012 12.6002 20.8012C11.168 20.8012 9.79452 20.2322 8.78182 19.2195C7.76912 18.2069 7.2002 16.8333 7.2002 15.4012C7.2002 13.969 7.76912 12.5955 8.78182 11.5828C9.79452 10.5701 11.168 10.0012 12.6002 10.0012C14.0324 10.0012 15.4059 10.5701 16.4186 11.5828C17.4313 12.5955 18.0002 13.969 18.0002 15.4012ZM13.2002 11.8012C13.2002 11.642 13.137 11.4894 13.0245 11.3769C12.9119 11.2644 12.7593 11.2012 12.6002 11.2012C12.4411 11.2012 12.2885 11.2644 12.1759 11.3769C12.0634 11.4894 12.0002 11.642 12.0002 11.8012V15.4012C12.0002 15.5603 12.0634 15.7129 12.1759 15.8254C12.2885 15.938 12.4411 16.0012 12.6002 16.0012H15.0002C15.1593 16.0012 15.3119 15.938 15.4245 15.8254C15.537 15.7129 15.6002 15.5603 15.6002 15.4012C15.6002 15.242 15.537 15.0894 15.4245 14.9769C15.3119 14.8644 15.1593 14.8012 15.0002 14.8012H13.2002V11.8012Z"
                    fill="#8787d6"
                  />
                </svg>
              ) : (
                <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.2 5.80039V0.400391H1.8C1.32261 0.400391 0.864773 0.590033 0.527208 0.927598C0.189642 1.26516 0 1.723 0 2.20039V17.8004C0 18.2778 0.189642 18.7356 0.527208 19.0732C0.864773 19.4107 1.32261 19.6004 1.8 19.6004H7.5084C6.66204 18.5777 6.14536 17.3226 6.0264 16.0004H5.4C5.24087 16.0004 5.08826 15.9372 4.97574 15.8247C4.86321 15.7121 4.8 15.5595 4.8 15.4004C4.8 15.2413 4.86321 15.0886 4.97574 14.9761C5.08826 14.8636 5.24087 14.8004 5.4 14.8004H6.0264C6.06304 14.3944 6.13736 13.9926 6.2484 13.6004H5.4C5.24087 13.6004 5.08826 13.5372 4.97574 13.4247C4.86321 13.3121 4.8 13.1595 4.8 13.0004C4.8 12.8413 4.86321 12.6886 4.97574 12.5761C5.08826 12.4636 5.24087 12.4004 5.4 12.4004H6.72C6.9396 11.9708 7.2048 11.5688 7.5084 11.2004H5.4C5.24087 11.2004 5.08826 11.1372 4.97574 11.0247C4.86321 10.9121 4.8 10.7595 4.8 10.6004C4.8 10.4413 4.86321 10.2886 4.97574 10.1761C5.08826 10.0636 5.24087 10.0004 5.4 10.0004H8.8044C9.8784 9.24439 11.1876 8.80039 12.6 8.80039C13.2086 8.79981 13.8143 8.8834 14.4 9.04879V7.60039H9C8.52261 7.60039 8.06477 7.41075 7.72721 7.07318C7.38964 6.73562 7.2 6.27778 7.2 5.80039ZM2.4 10.6004C2.4 10.4413 2.46321 10.2886 2.57574 10.1761C2.68826 10.0636 2.84087 10.0004 3 10.0004C3.15913 10.0004 3.31174 10.0636 3.42426 10.1761C3.53679 10.2886 3.6 10.4413 3.6 10.6004C3.6 10.7595 3.53679 10.9121 3.42426 11.0247C3.31174 11.1372 3.15913 11.2004 3 11.2004C2.84087 11.2004 2.68826 11.1372 2.57574 11.0247C2.46321 10.9121 2.4 10.7595 2.4 10.6004ZM2.4 13.0004C2.4 12.8413 2.46321 12.6886 2.57574 12.5761C2.68826 12.4636 2.84087 12.4004 3 12.4004C3.15913 12.4004 3.31174 12.4636 3.42426 12.5761C3.53679 12.6886 3.6 12.8413 3.6 13.0004C3.6 13.1595 3.53679 13.3121 3.42426 13.4247C3.31174 13.5372 3.15913 13.6004 3 13.6004C2.84087 13.6004 2.68826 13.5372 2.57574 13.4247C2.46321 13.3121 2.4 13.1595 2.4 13.0004ZM3 14.8004C3.15913 14.8004 3.31174 14.8636 3.42426 14.9761C3.53679 15.0886 3.6 15.2413 3.6 15.4004C3.6 15.5595 3.53679 15.7121 3.42426 15.8247C3.31174 15.9372 3.15913 16.0004 3 16.0004C2.84087 16.0004 2.68826 15.9372 2.57574 15.8247C2.46321 15.7121 2.4 15.5595 2.4 15.4004C2.4 15.2413 2.46321 15.0886 2.57574 14.9761C2.68826 14.8636 2.84087 14.8004 3 14.8004Z"
                    fill="#595959"
                  />
                  <path
                    d="M8.4002 5.80117V0.701172L14.1002 6.40117H9.0002C8.84107 6.40117 8.68845 6.33796 8.57593 6.22544C8.46341 6.11291 8.4002 5.9603 8.4002 5.80117ZM18.0002 15.4012C18.0002 16.8333 17.4313 18.2069 16.4186 19.2195C15.4059 20.2322 14.0324 20.8012 12.6002 20.8012C11.168 20.8012 9.79452 20.2322 8.78182 19.2195C7.76912 18.2069 7.2002 16.8333 7.2002 15.4012C7.2002 13.969 7.76912 12.5955 8.78182 11.5828C9.79452 10.5701 11.168 10.0012 12.6002 10.0012C14.0324 10.0012 15.4059 10.5701 16.4186 11.5828C17.4313 12.5955 18.0002 13.969 18.0002 15.4012ZM13.2002 11.8012C13.2002 11.642 13.137 11.4894 13.0245 11.3769C12.9119 11.2644 12.7593 11.2012 12.6002 11.2012C12.4411 11.2012 12.2885 11.2644 12.1759 11.3769C12.0634 11.4894 12.0002 11.642 12.0002 11.8012V15.4012C12.0002 15.5603 12.0634 15.7129 12.1759 15.8254C12.2885 15.938 12.4411 16.0012 12.6002 16.0012H15.0002C15.1593 16.0012 15.3119 15.938 15.4245 15.8254C15.537 15.7129 15.6002 15.5603 15.6002 15.4012C15.6002 15.242 15.537 15.0894 15.4245 14.9769C15.3119 14.8644 15.1593 14.8012 15.0002 14.8012H13.2002V11.8012Z"
                    fill="#595959"
                  />
                </svg>
              )}
            </div>
            <div className="title-select-infor">History</div>
          </button>
        </div>
        <div>
          <Accordion defaultActiveKey={['0']} alwaysOpen>
            <Accordion.Item className="bg-transparent border-dark boder-bottom-accordion" eventKey="0">
              <Accordion.Header className="bg-transparent bg-accordion-body border-radius-8 position-relative">
                <Row className="width-without-dropdown">
                  <Col xs="7" className="d-flex align-items-center">
                    <img width={30} height={30} className="m-r-10" src={talk} alt="" />
                    <span className="dark:text-white text-black fw-6 fs-12">
                      {/*{parseFloat(talkBals[0]).toFixed(3)} TALK*/}
                      {sumTalkBal(talkBals)} TALK
                    </span>
                  </Col>
                  <Col xs="5" className="text-right d-flex justify-content-end p-r-4">
                    <div
                      className="button border-0 m-r-4 p-b-4 pointer-event p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                      onClick={(e) => {
                        e.stopPropagation();
                        openDetailModal(talk, myAddress, `${SCAN_URL[env.REACT_APP_TARGET_NETWORK_ETH]}address/`);
                      }}
                    >
                      <Download width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                    </div>
                    <div
                      className="button m-r-4 border-0 p-b-4 pointer p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                      onClick={(e) => {
                        e.stopPropagation();
                        isOpenTransferModal(0, talkBals[0], myAddress);
                      }}
                    >
                      <Send width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                    </div>
                    <div className="text-right d-flex justify-content-end">
                      <div
                        className="button border-0 p-b-2 pointer p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                        onClick={(e) => {
                          e.stopPropagation();
                          onClickOpenTransferTalkenBridge(0);
                        }}
                      >
                        <Trans width={16} height={16} className="transfer-color-525298 dark:transfer-color-525298" />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Accordion.Header>
              <Accordion.Body className="bg-accordion-body boder-bottom-accordion border-radius-8">
                {/* TODOD : 디자인을 어떻게 할지 기획이 필요함 !! */}
                <Row>
                  <Col className="d-flex align-items-center">
                    <img width={30} height={30} className="m-r-10" src={talkEthereum} alt="" />
                    <span className="dark:text-white text-black fw-6 fs-12">
                      {talkBals[0] === undefined
                        ? parseFloat('0.0').toFixed(3)
                        : parseFloat(talkBals[0])
                            .toFixed(4)
                            ?.slice(0, parseFloat(talkBals[0]).toFixed(4)?.length - 1)}{' '}
                      TALK
                    </span>
                  </Col>
                  <Col xs="5" className="text-right d-flex justify-content-end p-r-4">
                    <div
                      className="button border-0 m-r-4 p-b-4 pointer-event p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                      onClick={(e) => {
                        e.stopPropagation();
                        openDetailModal(
                          talkEthereum,
                          myAddress,
                          `${SCAN_URL[env.REACT_APP_TARGET_NETWORK_ETH]}address/`
                        );
                      }}
                    >
                      <Download width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                    </div>
                    <div
                      className="button m-r-4 border-0 p-b-4 pointer p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                      onClick={(e) => {
                        e.stopPropagation();
                        isOpenTransferModal(0, talkBals[0], myAddress);
                      }}
                    >
                      <Send width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                    </div>
                    <div className="text-right d-flex justify-content-end">
                      <div
                        className="button border-0 p-b-2 pointer p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                        onClick={(e) => {
                          e.stopPropagation();
                          onClickOpenTransferTalkenBridge(0);
                        }}
                      >
                        <Trans width={16} height={16} className="transfer-color-525298 dark:transfer-color-525298" />
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row className="p-t-10">
                  <Col className="d-flex align-items-center">
                    <img width={30} height={30} className="m-r-10" src={talkBinance} alt="" />
                    <span className="dark:text-white text-black fw-6 fs-12">
                      {talkBals[3] === undefined
                        ? parseFloat('0.0').toFixed(3)
                        : parseFloat(talkBals[3])
                            .toFixed(4)
                            ?.slice(0, parseFloat(talkBals[3]).toFixed(4)?.length - 1)}{' '}
                      TALK
                    </span>
                  </Col>
                  <Col xs="5" className="text-right d-flex justify-content-end p-r-4">
                    <div
                      className="button border-0 m-r-4 p-b-4 pointer-event p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                      onClick={(e) => {
                        e.stopPropagation();
                        openDetailModal(
                          talkBinance,
                          myAddress,
                          `${SCAN_URL[env.REACT_APP_TARGET_NETWORK_BNB]}address/`
                        );
                      }}
                    >
                      <Download width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                    </div>
                    <div
                      className="button m-r-4 border-0 p-b-4 pointer p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                      onClick={(e) => {
                        e.stopPropagation();
                        isOpenTransferModal(1, talkBals[3], myAddress);
                      }}
                    >
                      <Send width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                    </div>
                    <div className="text-right d-flex justify-content-end">
                      <div
                        className="button border-0 p-b-2 pointer p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                        onClick={(e) => {
                          e.stopPropagation();
                          onClickOpenTransferTalkenBridge(3);
                        }}
                      >
                        <Trans width={16} height={16} className="transfer-color-525298 dark:transfer-color-525298" />
                      </div>
                    </div>
                  </Col>
                </Row>
                {process.env.REACT_APP_PHASE !== 'development' && (
                  <Row className="p-t-10">
                    <Col className="d-flex align-items-center">
                      <img width={30} height={30} className="m-r-10" src={talkPolygon} alt="" />
                      <span className="dark:text-white text-black fw-6 fs-12">
                        {talkBals[1] === undefined
                          ? parseFloat('0.0').toFixed(3)
                          : parseFloat(talkBals[1])
                              .toFixed(4)
                              ?.slice(0, parseFloat(talkBals[1]).toFixed(4)?.length - 1)}{' '}
                        TALK
                      </span>
                    </Col>
                    <Col xs="5" className="text-right d-flex justify-content-end p-r-4">
                      <div
                        className="button border-0 m-r-4 p-b-4 pointer-event p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                        onClick={(e) => {
                          e.stopPropagation();
                          openDetailModal(
                            talkPolygon,
                            myAddress,
                            `${SCAN_URL[env.REACT_APP_TARGET_NETWORK_MATIC]}address/`
                          );
                        }}
                      >
                        <Download width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                      </div>
                      <div
                        className="button m-r-4 border-0 p-b-4 pointer p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                        onClick={(e) => {
                          e.stopPropagation();
                          isOpenTransferModal(2, talkBals[1], myAddress);
                        }}
                      >
                        <Send width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                      </div>
                      <div className="text-right d-flex justify-content-end">
                        <div
                          className="button border-0 p-b-2 pointer p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                          onClick={(e) => {
                            e.stopPropagation();
                            onClickOpenTransferTalkenBridge(1);
                          }}
                        >
                          <Trans width={16} height={16} className="transfer-color-525298 dark:transfer-color-525298" />
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}
                <Row className="p-t-10">
                  <Col className="d-flex align-items-center">
                    <img width={30} height={30} className="m-r-10" src={talkKlaytn} alt="" />
                    <span className="dark:text-white text-black fw-6 fs-12">
                      {talkBals[2] === undefined
                        ? parseFloat('0.0').toFixed(3)
                        : parseFloat(talkBals[2])
                            .toFixed(4)
                            ?.slice(0, parseFloat(talkBals[2]).toFixed(4)?.length - 1)}{' '}
                      TALK
                    </span>
                  </Col>
                  <Col xs="5" className="text-right d-flex justify-content-end p-r-4">
                    <div
                      className="button border-0 m-r-4 p-b-4 pointer-event p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                      onClick={(e) => {
                        e.stopPropagation();
                        openDetailModal(
                          talkKlaytn,
                          myAddress,
                          `${SCAN_URL[env.REACT_APP_TARGET_NETWORK_KLAY]}account/`
                        );
                      }}
                    >
                      <Download width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                    </div>
                    <div
                      className="button m-r-4 border-0 p-b-4 pointer p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                      onClick={(e) => {
                        e.stopPropagation();
                        isOpenTransferModal(3, talkBals[2], myAddress);
                      }}
                    >
                      <Send width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                    </div>
                    <div className="text-right d-flex justify-content-end">
                      <div
                        className="button border-0 p-b-2 pointer p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                        onClick={(e) => {
                          e.stopPropagation();
                          onClickOpenTransferTalkenBridge(2);
                        }}
                      >
                        <Trans width={16} height={16} className="transfer-color-525298 dark:transfer-color-525298" />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <Accordion defaultActiveKey={['0']} alwaysOpen>
            <Accordion.Item className="bg-transparent border-dark m-t-10 boder-top-accordion" eventKey="0">
              <Accordion.Header className="bg-transparent bg-accordion-body border-radius-8 position-relative">
                <Row className="width-without-dropdown">
                  <Col xs="7" className="d-flex align-items-center">
                    <img width={30} height={30} className="m-r-10" src={eth} alt="" />
                    <span className="dark:text-white text-black fw-6 fs-12">
                      {ethBal === undefined
                        ? parseFloat('0.0').toFixed(3)
                        : parseFloat(ethBal)
                            .toFixed(4)
                            ?.slice(0, parseFloat(ethBal).toFixed(4)?.length - 1)}{' '}
                      ETH
                    </span>
                  </Col>
                  <Col xs="5" className="text-right d-flex justify-content-end p-r-4">
                    <div
                      className="button border-0 m-r-4 p-b-2 pointer-event p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                      onClick={(e) => {
                        e.stopPropagation();
                        openDetailModal(eth, myAddress, `${SCAN_URL[env.REACT_APP_TARGET_NETWORK_ETH]}address/`);
                      }}
                    >
                      <Download width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                    </div>
                    <div
                      className="button border-0 p-b-2 pointer p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                      onClick={(e) => {
                        e.stopPropagation();
                        isOpenTransferModal(4, ethBal, myAddress);
                      }}
                    >
                      <Send width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                    </div>
                  </Col>
                </Row>
              </Accordion.Header>
              <Accordion.Body className="bg-accordion-body border-radius-8">
                <Row>
                  <Col xs="7" className="d-flex align-items-center">
                    <img width={30} height={30} className="m-r-10" src={binance} alt="" />
                    <span className="dark:text-white text-black fw-6 fs-12">
                      {bnbBal === undefined
                        ? parseFloat('0.0').toFixed(3)
                        : parseFloat(bnbBal)
                            .toFixed(4)
                            ?.slice(0, parseFloat(bnbBal).toFixed(4)?.length - 1)}{' '}
                      BNB
                    </span>
                  </Col>
                  <Col xs="5" className="text-right d-flex justify-content-end p-r-4">
                    <div
                      className="button border-0 m-r-4 p-b-2 pointer-event p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                      onClick={() =>
                        openDetailModal(binance, myAddress, `${SCAN_URL[env.REACT_APP_TARGET_NETWORK_BNB]}address/`)
                      }
                    >
                      <Download width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                    </div>
                    <div
                      className="button border-0 p-b-2 pointer p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                      onClick={() => isOpenTransferModal(5, bnbBal, myAddress)}
                    >
                      <Send width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                    </div>
                  </Col>
                </Row>
                <Row className="p-t-10">
                  <Col xs="7" className="d-flex align-items-center">
                    <img width={30} height={30} className="m-r-10" src={polygon} alt="" />
                    <span className="dark:text-white text-black fw-6 fs-12">
                      {maticBal === undefined
                        ? parseFloat('0.0').toFixed(3)
                        : parseFloat(maticBal)
                            .toFixed(4)
                            ?.slice(0, parseFloat(maticBal).toFixed(4)?.length - 1)}{' '}
                      MATIC
                    </span>
                  </Col>
                  <Col xs="5" className="text-right d-flex justify-content-end p-r-4">
                    <div
                      className="button border-0 m-r-4 p-b-2 pointer-event p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                      onClick={() =>
                        openDetailModal(polygon, myAddress, `${SCAN_URL[env.REACT_APP_TARGET_NETWORK_MATIC]}address/`)
                      }
                    >
                      <Download width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                    </div>
                    <div
                      className="button border-0 p-b-2 pointer p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                      onClick={() => isOpenTransferModal(6, maticBal, myAddress)}
                    >
                      <Send width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                    </div>
                  </Col>
                </Row>
                <Row className="p-t-10">
                  <Col xs="7" className="d-flex align-items-center">
                    <img width={30} height={30} className="m-r-10" src={klaytn} alt="" />
                    <span className="dark:text-white text-black fw-6 fs-12">
                      {klayBal === undefined
                        ? parseFloat('0.0').toFixed(3)
                        : parseFloat(klayBal)
                            .toFixed(4)
                            ?.slice(0, parseFloat(klayBal).toFixed(4)?.length - 1)}{' '}
                      KLAY
                    </span>
                  </Col>
                  <Col xs="5" className="text-right d-flex justify-content-end p-r-4">
                    <div
                      className="button border-0 m-r-4 p-b-2 pointer-event p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                      onClick={() =>
                        openDetailModal(klaytn, myAddress, `${SCAN_URL[env.REACT_APP_TARGET_NETWORK_KLAY]}account/`)
                      }
                    >
                      <Download width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                    </div>
                    <div
                      className="button border-0 p-b-2 pointer p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"
                      onClick={() => isOpenTransferModal(7, klayBal, myAddress)}
                    >
                      <Send width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />
                    </div>
                  </Col>
                </Row>
                {/*<Row className="mt-2">*/}
                {/*  <Col xs="7" className="d-flex align-items-center">*/}
                {/*    <img width={30} height={30} className="m-r-10" src={klaytn} alt="" />*/}
                {/*    <span className="dark:text-white text-black fw-6 fs-12">*/}
                {/*      {parseFloat(wklayBal).toFixed(3)} WKLAY*/}
                {/*    </span>*/}
                {/*  </Col>*/}
                {/*  <Col xs="5" className="text-right d-flex justify-content-end p-r-4">*/}
                {/*    /!*<button*!/*/}
                {/*    /!*  className="border-0 m-r-10 p-b-2 pointer-event p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"*!/*/}
                {/*    /!*  onClick={() => openDetailModal(klaytn, myAddress)}*!/*/}
                {/*    /!*>*!/*/}
                {/*    /!*  <Download width={16} height={16} className="svg-color-525298 dark:svg-color-525298" />*!/*/}
                {/*    /!*</button>*!/*/}
                {/*    <div*/}
                {/*      className="button border-0 p-b-2 pointer p-l-8 p-r-8 p-t-8 rounded-circle hover-opa-7"*/}
                {/*      onClick={() => isOpenTransferWklay(2, klayBal, myAddress)}*/}
                {/*    >*/}
                {/*      <Trans width={16} height={16} className="transfer-color-525298 dark:transfer-color-525298" />*/}
                {/*    </div>*/}
                {/*  </Col>*/}
                {/*</Row>*/}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
      {isShowDetaiWallet && (
        <WalletDetailModal show={isShowDetaiWallet} onHide={() => setIsShowDetailWallet(false)} data={walletInfo} />
      )}
      {isOpenTransfer && (
        <TransferModal
          data={transferInfo}
          show={isOpenTransfer}
          onHide={() => setIsOpenTransfer(false)}
          typeModal={''}
          openWinningComplete={(data) => {
            setDataComplete(data);
            setIsOpenTransfer(false);
            // setIsOpenTransferOTP(true);
            setIsOpenTransferSucces(true);
          }}
          setReload={setReload}
        ></TransferModal>
      )}
      {isOpenTransferOTP && (
        <TranferOTPModal
          show={isOpenTransferOTP}
          onHide={() => setIsOpenTransferOTP(false)}
          typeModal={''}
          openWinningComplete={() => {
            setIsOpenTransferOTP(false);
            setIsOpenTransferSucces(true);
          }}
        ></TranferOTPModal>
      )}
      {isOpenTransferSucces && (
        <TransferSuccessModal
          data={dataComplete}
          show={isOpenTransferSucces}
          onHide={() => setIsOpenTransferSucces(false)}
          typeModal={''}
          openWinningComplete={() => setIsOpenTransferSucces(false)}
        ></TransferSuccessModal>
      )}
      {/*{isOpenTransferKlayToWklay && (*/}
      {/*  <WrapUnwrapKlay*/}
      {/*    balances={wklayData}*/}
      {/*    show={isOpenTransferKlayToWklay}*/}
      {/*    onHide={() => setIsOpenTransferWklay(false)}*/}
      {/*    typeModal={''}*/}
      {/*    openWinningComplete={(data) => {*/}
      {/*      setDataWrapComplete(data);*/}
      {/*      setIsOpenTransferWklay(false);*/}
      {/*      // setIsOpenTransferOTP(true);*/}
      {/*      setIsOpenWrapSucces(true);*/}
      {/*    }}*/}
      {/*    setReload={setReload}*/}
      {/*  ></WrapUnwrapKlay>*/}
      {/*)}*/}
      {/*{isOpenTalkenBridge && (*/}
      {/*  <TalkenBridge*/}
      {/*    show={isOpenTalkenBridge}*/}
      {/*    onHide={() => setIsOpenTalkenBridge(false)}*/}
      {/*    typeModal={''}*/}
      {/*    openWinningComplete={(data) => {*/}
      {/*      setDataTalkenBridgeComplete(data);*/}
      {/*      setIsOpenTalkenBridge(false);*/}
      {/*      // setIsOpenTransferOTP(true);*/}
      {/*      setIsOpenTalkenBridgeSucces(true);*/}
      {/*    }}*/}
      {/*    selected={selected}*/}
      {/*  ></TalkenBridge>*/}
      {/*)}*/}
      {isOpenWrapSucces && (
        <TransferSuccessWklay
          show={isOpenWrapSucces}
          onHide={() => setIsOpenWrapSucces(false)}
          typeModal={''}
          data={dataWrapComplete}
          openWinningComplete={() => setIsOpenWrapSucces(false)}
        ></TransferSuccessWklay>
      )}
      {isOpenTalkenBridgeSucces && (
        <TalkenBridgeSuccess
          show={isOpenTalkenBridgeSucces}
          onHide={() => setIsOpenTalkenBridgeSucces(false)}
          typeModal={''}
          openWinningComplete={() => setIsOpenTalkenBridgeSucces(false)}
          data={dataTalkenBridgeComplete}
          setReload={setReload}
        ></TalkenBridgeSuccess>
      )}
    </>
  );
};

export default AggregateUserInfor;
